export default "__VITE_ASSET__DvKbiZPG__"